var React = require('react');

function Pensile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M271.315 54.522L218.989 2.196a7.502 7.502 0 00-10.607 0L78.274 132.303a7.51 7.51 0 00-2.053 3.843l-12.964 65.29a7.503 7.503 0 002.053 6.765 7.503 7.503 0 006.765 2.052l65.29-12.964a7.505 7.505 0 003.843-2.053L271.315 65.129a7.5 7.5 0 000-10.607zM83.182 178.114l6.776-34.127 39.566 39.566-34.127 6.776-12.215-12.215zM205.912 227.066c-71.729-30.029-118.425 19.633-132.371 27.175-17.827 9.641-42.941 20.97-48.779 1.358-3.522-11.832 15.521-24.479 28.131-28.42 9.2-2.876 5.271-17.358-3.988-14.465-19.582 6.121-42.948 22.616-38.851 45.839 3.044 17.256 24.67 32.995 66.368 11.114 30.308-15.902 50.897-48.84 114.733-31.783 20.969 5.602 37.92 19.27 45.178 40.057 3.168 9.07 17.662 5.169 14.465-3.988-7.736-22.154-23.387-37.886-44.886-46.887z"}));
}

Pensile.defaultProps = {"viewBox":"0 0 283.093 283.093"};

module.exports = Pensile;

Pensile.default = Pensile;
